export const FEATURE_ANNOUNCEMENT = "FeatureAnnouncement"
export const MESSAGE = "Message"
